<script setup>

import {Link} from "@inertiajs/vue3";

import {onMounted, ref, watch} from 'vue';

const gap = ref(0);
const ready = ref(false);
const show = ref(true);

const getGap = () => {

	ready.value = false;

	return axios.get(route('cart.free_shipping_gap')).then(response => {
		gap.value = response.data.gap;

		if(gap.value > 0){

			// Show message
			ready.value = true;

		}else{

			// Hide entire component
			show.value = false;

		}

	});

}

// Get gap on component mount
onMounted(() => {
	getGap();
});

// Access the store
import { useStore } from 'vuex';
const store = useStore();

// Watch vuex cart store subtotal and get gap if subtotal changes
watch(() => {
	return store.state.cart.subtotal;
}, (newVal, oldVal) => {
	getGap();
});





</script>

<template>
	<div v-if="show">
		<span class="w-100 text-center text-warning font-semibold" v-if="ready">
			<Link :href="route('home')">
				{{
					__('shipping.add_x_amount_to_cart_for_free_shipping', {
							'amount': gap.toFixed(2),
							'currency': $page.props.store.currency_symbol || $page.props.store.currency_code
						}
					)
				}}
			</Link>
		</span>

		<div class="spinner w-100 mt-2" v-else>
			<div class="bounce1"></div>
			<div class="bounce2"></div>
			<div class="bounce3"></div>
		</div>

	</div>
</template>

<script>
export default {
	name: "FreeShippingMessage"
}
</script>

<style scoped>

</style>